/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RankingInfo interface.
 */
export function instanceOfRankingInfo(value) {
    if (!('nResponses' in value) || value['nResponses'] === undefined)
        return false;
    if (!('nPositiveResponses' in value) || value['nPositiveResponses'] === undefined)
        return false;
    if (!('avgResponseTime' in value) || value['avgResponseTime'] === undefined)
        return false;
    if (!('nResponsesRank' in value) || value['nResponsesRank'] === undefined)
        return false;
    if (!('nPositiveResponsesRank' in value) || value['nPositiveResponsesRank'] === undefined)
        return false;
    if (!('avgResponseTimeRank' in value) || value['avgResponseTimeRank'] === undefined)
        return false;
    return true;
}
export function RankingInfoFromJSON(json) {
    return RankingInfoFromJSONTyped(json, false);
}
export function RankingInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'nResponses': json['n_responses'],
        'nPositiveResponses': json['n_positive_responses'],
        'avgResponseTime': json['avg_response_time'],
        'nResponsesRank': json['n_responses_rank'],
        'nPositiveResponsesRank': json['n_positive_responses_rank'],
        'avgResponseTimeRank': json['avg_response_time_rank'],
    };
}
export function RankingInfoToJSON(json) {
    return RankingInfoToJSONTyped(json, false);
}
export function RankingInfoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'n_responses': value['nResponses'],
        'n_positive_responses': value['nPositiveResponses'],
        'avg_response_time': value['avgResponseTime'],
        'n_responses_rank': value['nResponsesRank'],
        'n_positive_responses_rank': value['nPositiveResponsesRank'],
        'avg_response_time_rank': value['avgResponseTimeRank'],
    };
}
